import { apiCall, ApiConfig } from '../../../config/api'
import { SupplierOrigin } from '../../../interfaces/Supplier/SupplierOrigin/SupplierOrigin'
import { Filter } from '../../../components/_WMS/FilterComponent/types'
import { GenericOrderBy } from '../../../components/_EOS/Table/types'

export const getSupplierOrigins = (filters: Filter[], page: number, pageSize: number, orderBy?: GenericOrderBy<SupplierOrigin>) => {
  const queryParams = new URLSearchParams()
  queryParams.append('pageIndex', page.toString())
  queryParams.append('pageSize', pageSize.toString())
  
  filters.forEach(filter => {
    queryParams.append(filter.key, filter.value)
  })

  // Agregar parámetros de ordenamiento
  if (orderBy) {
    const sorters = {
      datafield: orderBy.field.toString(),
      sortOrder: orderBy.direction
    }
    queryParams.append('sorters', JSON.stringify(sorters))
  }
  
  return apiCall('GET', `${ApiConfig.SupplierOriginApi}?${queryParams.toString()}`)
}

export const createSupplierOrigin = (data: SupplierOrigin) => {
  return apiCall('POST', ApiConfig.SupplierOriginApi, data)
}

export const updateSupplierOrigin = (id: number, data: SupplierOrigin) => {
  return apiCall('PUT', `${ApiConfig.SupplierOriginApi}/${id}`, data)
}

export const deleteSupplierOrigin = (id: number) => {
  return apiCall('DELETE', `${ApiConfig.SupplierOriginApi}/${id}`)
}
